"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createManufacturerOutputDtoSchema = exports.createManufacturerInputDtoSchema = void 0;
const zod_1 = require("zod");
const hil_manufacturer_js_1 = require("../../types/hil-manufacturer.js");
exports.createManufacturerInputDtoSchema = zod_1.z.object({
    name: zod_1.z.string(),
});
exports.createManufacturerOutputDtoSchema = zod_1.z.object({
    manufacturer: hil_manufacturer_js_1.HilManufacturer.schema,
});
//# sourceMappingURL=create-manufacturer.dto.js.map